window.initPt413 = function () {
  const productCards = document.querySelector(".Product__Info");
  if (!productCards) return;

  function replaceWithClone(parent, selector) {
    const el = parent.querySelector(selector);
    if (!el) return null;
    const clone = el.cloneNode(true);
    el.parentNode.replaceChild(clone, el);
    return clone;
  }

  function restoreSellingPlanFromDropdown() {
    const select = productCards.querySelector(".SellingPlan__Selector");
    const hiddenInput = productCards.querySelector('input[name="selling_plan"]');
    if (select && hiddenInput) {
      hiddenInput.value = select.value;
    }
  }

  function initToggle() {
    const optionWidget       = productCards.querySelector(".rc-widget");
    const onetimeOption      = optionWidget?.querySelector(".onetime-radio");
    const subscriptionOption = optionWidget?.querySelector(".subscription-radio");
    const onetimeWrapper     = productCards.querySelector(".pt_413_onetime_wrapper");
    const subscriptionWrapper= productCards.querySelector(".pt_413_subscription_wrapper");

    if (!optionWidget || !onetimeOption || !subscriptionOption) return false;

    const toggleOneTime      = replaceWithClone(productCards, ".pt_413_toggle_input_one_time");
    const toggleSubscription = replaceWithClone(productCards, ".pt_413_toggle_input_subscription");
    const onetimeLeftLowerCTA= replaceWithClone(productCards, ".pt_413_onetime_left_lower_cta");

    // Default: Subscribe & Save active
    subscriptionOption.click();
    setTimeout(restoreSellingPlanFromDropdown, 0);
    onetimeWrapper?.classList.add("pt_413_hidden");
    subscriptionWrapper?.classList.remove("pt_413_hidden");
    productCards.querySelector(".bfcm-banner-pdp")?.classList.remove("pt_413_hidden");

    toggleOneTime?.addEventListener("click", function () {
      subscriptionOption.click();
      setTimeout(restoreSellingPlanFromDropdown, 0);
      onetimeWrapper?.classList.add("pt_413_hidden");
      subscriptionWrapper?.classList.remove("pt_413_hidden");
      productCards.querySelector(".bfcm-banner-pdp")?.classList.remove("pt_413_hidden");
    });

    toggleSubscription?.addEventListener("click", function () {
      onetimeOption.click();
      subscriptionWrapper?.classList.add("pt_413_hidden");
      onetimeWrapper?.classList.remove("pt_413_hidden");
      productCards.querySelector(".bfcm-banner-pdp")?.classList.add("pt_413_hidden");
    });

    onetimeLeftLowerCTA?.addEventListener("click", function () {
      subscriptionOption.click();
      setTimeout(restoreSellingPlanFromDropdown, 0);
      subscriptionOption.classList.add("PT242__OptionWidget--Active");
      onetimeOption.classList.remove("PT242__OptionWidget--Active");
      onetimeWrapper?.classList.add("pt_413_hidden");
      subscriptionWrapper?.classList.remove("pt_413_hidden");
      productCards.querySelector(".bfcm-banner-pdp")?.classList.remove("pt_413_hidden");
    });

    return true;
  }

  if (initToggle()) return;

  // RC widget not in DOM yet — wait for it
  const observer = new MutationObserver(function () {
    if (initToggle()) observer.disconnect();
  });
  observer.observe(productCards, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), 10000);
};
document.addEventListener("DOMContentLoaded", window.initPt413);